import { render, staticRenderFns } from "./ResultDashboard.vue?vue&type=template&id=d66bcc90&scoped=true&"
import script from "./ResultDashboard.vue?vue&type=script&lang=js&"
export * from "./ResultDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ResultDashboard.vue?vue&type=style&index=0&id=d66bcc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66bcc90",
  null
  
)

export default component.exports